import { Link, Navigate } from "react-router-dom";
import SideNav from "../../../../components/dashboard/Sidebar";
import { connect } from "react-redux";
import { useEffect } from "react";
import { IconPencil, IconPlus } from "@tabler/icons-react";
import SetPagination from "../../../../components/pagination/SetPagination";
import {
  get_categories_list,
  get_categories_list_page,
} from "../../../../redux/actions/categories";

function DashboardCategories({
  isAuthenticated,
  get_categories_list,
  get_categories_list_page,
  categories,
  count,
}) {
  useEffect(() => {
    if (isAuthenticated) {
      get_categories_list();
    }
  }, [isAuthenticated, get_categories_list]);

  if (!isAuthenticated) return <Navigate to="/" />;

  return (
    <SideNav>
      <div className="container mx-auto px-4 sm:px-8">
        <div className="flex justify-between items-center mt-4">
          <h1 className="text-2xl font-semibold text-gray-900">Categorías</h1>
          <Link
            to="/add-category"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <IconPlus className="h-5 w-5 mr-2" />
            Agregar Categoría
          </Link>
        </div>
        <div className="mt-8">
          <div className="flex flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200 text-center">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Categoría Principal
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Subcategorías
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Fecha de Creación
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {categories &&
                        categories.map((category) => (
                          <tr key={category.id}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {category.parent_name || category.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {category.parent
                                ? category.name
                                : "Sin subcategorías"}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {new Date(category.created_at).toLocaleDateString(
                                "es-ES",
                                {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                },
                              )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <div className="flex tooltip" data-tip="Editar">
                                <Link
                                  to={`/edit-category/${category.id}`}
                                  className="p-1 text-white bg-yellow-500 rounded-full"
                                >
                                  <IconPencil />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <SetPagination
                  list_page={get_categories_list_page}
                  count={count}
                  type="medium"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SideNav>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
  categories: state.CategoriesFull.categories,
  count: state.CategoriesFull.count,
});

export default connect(mapStateToProps, {
  get_categories_list,
  get_categories_list_page,
})(DashboardCategories);
